import type { FC } from 'react';

import { useGiftGoods } from '@/shared/hooks/apis';
import { UIDivider as Divider } from '@/shared/ui/common/Divider';
import { ProductGrid } from '@/shared/ui/gift-detail';

type GiftProductSectionProps = {
  giftNo: number;
};

const GiftProductSection: FC<GiftProductSectionProps> = ({ giftNo }) => {
  const { data: goodsData, hasNextPage, fetchNextPage, isFetchingNextPage } = useGiftGoods(giftNo);

  const products = goodsData.pages.flatMap((page) => page.data.list);

  if (products.length === 0) return null;

  return (
    <>
      <Divider />
      <ProductGrid
        products={products}
        hasMore={hasNextPage}
        onLoadMore={fetchNextPage}
        isLoading={isFetchingNextPage}
      />
    </>
  );
};

export { GiftProductSection };
